import {
    BEHAVIOR_GET_MULTIPLE,
    BEHAVIOR_GET_ONE,
    BEHAVIOR_REGISTER_SUCCESS,
    BEHAVIOR_REGISTER_FAIL,
    BEHAVIOR_LOADING,
    BEHAVIOR_LOADING_ERROR,
    BEHAVIOR_ACTIVATE_FAIL,
    BEHAVIOR_ACTIVATE_SUCCESS,
    BEHAVIOR_UPDATE_SUCCESS,
    BEHAVIOR_UPDATE_FAIL,
    BEHAVIOR_DELETE_SUCCESS,
    BEHAVIOR_DELETE_FAIL,
    BEHAVIOR_EDIT
} from "./../types/behavior";

let behaviorStore = JSON.parse(localStorage.getItem('behavior'))

const initialState = {
    isLoading: false,
    behaviors: behaviorStore ? behaviorStore : [],
    behavior:{},
    msg: null,
    isEdit:-1,
    ref:null,
}

const changeState = (aluu, actid) =>
{
    let newBehavior = [...aluu];
    newBehavior.forEach(alu => {
        if(alu.id == actid.id){
            alu.is_active = actid.is_active
        }
    });
    return newBehavior;
}
const func =  function(state = initialState, action){
    switch (action.type) {
        case BEHAVIOR_EDIT:
            return {
                ...state,
                isEdit : action.payload
        };
        case BEHAVIOR_LOADING:
            return {
                ...state,
                isLoading : true
            };
        case BEHAVIOR_GET_MULTIPLE:
            localStorage.setItem('behavior', JSON.stringify(action.payload));
            return {
                ...state,
                behaviors : action.payload,
                behavior : action.payload,
                isLoading : false,
                msg:'DONE!!!'
            };
        case BEHAVIOR_GET_ONE:
            let all = [...state.behaviors];
            let ses = all.filter(row=>row.id == action.payload)[0];
            return {
                ...state,
                behavior : ses,
                MSG:"DONE!!!"
            };
        case BEHAVIOR_REGISTER_SUCCESS:
            localStorage.setItem('behavior', JSON.stringify([...state.behaviors, action.payload]));
            return {
                ...state,
                behaviors: [...state.behaviors, action.payload],
                msg:action.msg
            }; 
        case BEHAVIOR_ACTIVATE_SUCCESS:
            let ac = changeState(state.behaviors, action.payload);
            localStorage.setItem('behavior', JSON.stringify(ac));
            return{
                ...state,
                msg:'DONE!!!',
                behaviors: ac
            }
        case BEHAVIOR_DELETE_SUCCESS:
            let rem = state.behaviors.filter(cat => cat.id != action.payload);
            localStorage.setItem('behavior', JSON.stringify(rem));
            return{
                ...state,
                msg:'DONE!!!',
                behaviors: rem
            }
        case BEHAVIOR_UPDATE_SUCCESS:
            const findInd = state.behaviors.findIndex(cat => cat.id == action.payload.id);
            let newState = [...state.behaviors];
            newState[findInd] = action.payload;
            localStorage.setItem('behavior', JSON.stringify(newState));
            return {
                ...state,
                ...action.payload,
                behaviors : newState,
                behavior:action.payload
            }; 
        case BEHAVIOR_LOADING_ERROR:
        case BEHAVIOR_ACTIVATE_FAIL:
        case BEHAVIOR_REGISTER_FAIL:
        case BEHAVIOR_DELETE_FAIL:
        case BEHAVIOR_UPDATE_FAIL:

            return {
                ...state,
                isLoading: false,
                msg: action.msg
            };
        default:
            return state;
    }

}
export default func